@if (isLoading) {
  <div
    class="flex flex-col justify-center items-center"
    [style.height]="'100vh'"
    >
    <kendo-loader type="infinite-spinner" class="color-primary" size="large">
    </kendo-loader>
  </div>
} @else {
  <div kendoDialogContainer></div>
  @if (isAuthenticated) {
    <app-payment-popup [paymentStatus]="paymentStatus$ | async"></app-payment-popup>
    <router-outlet></router-outlet>
  }
  @if (isAuthenticated && isUserDataLoaded) {
    <app-usersnap></app-usersnap>
    <!-- ZEY-3181: server-side announcements (the ZEY-3140 password change among them); shows nothing unless due. -->
    @if (!isIframe) {
      <app-announcement-host></app-announcement-host>
    }
  }
}
